import { Row, Col } from "antd";
import React, { useState, useEffect } from "react";
import PersonalDetails from "../createStaff";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getStaffOnboard,
  getStaffOnboardClear,
} from "../../../../actionsMethods/onboardingMethods";

export const StaffOnboardingSteps = ({ changeTab }) => {
  const [current, setCurrent] = useState(0);
  const dispatch = useDispatch();
  const getStaffId = localStorage.getItem("staff");

  const getFormData = useSelector(
    (state) => state.onboardingReducer.getStaffOnboardReducer,
    shallowEqual
  );

  const { result: formResult } = getFormData;

  useEffect(() => {
    if (!getStaffId?.includes("null") && getStaffId !== null) {
      dispatch(getStaffOnboard(getStaffId));
    } else {
      dispatch(getStaffOnboardClear());
    }
  }, [getStaffId, current]);

  const handleStepsChange = (params) => {
    setCurrent(params);
  };

  return (
    <div className="master-main-container">
      <Row className="p-1">
        <Col span={24} className="global-steps-contner">
          {current === 0 ? (
            <PersonalDetails
              handleStepsChange={handleStepsChange}
              formResult={formResult}
              current={current}
              changeTab={changeTab}
            />
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default StaffOnboardingSteps;
